import { render } from "./Voices.vue?vue&type=template&id=e0c780be"
import script from "./Voices.vue?vue&type=script&lang=js"
export * from "./Voices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__